// import './part_search/modules/part_search'

(function($) {
    "use strict";

    var getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;
        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
    };
    $(document).ready(function() {
        var search = getUrlParameter('q');
        if (search != "") {
            $('#searchForm input').val(search.replace(/\+/g, ' '));
            $('#searchForm').toggle();
        }
    });

})(jQuery);